"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { tbShowFilterBtnClicked } from "Actions/Table/TableToolBarActions";
import BaseToolbarButtonProp from "./BaseToolbarButton";
import { Messages } from "Messages";

var ShowHeaderRowFilterButtonProp =
/*#__PURE__*/
function (_BaseToolbarButtonPro) {
  _inherits(ShowHeaderRowFilterButtonProp, _BaseToolbarButtonPro);

  function ShowHeaderRowFilterButtonProp(_ref) {
    var _this;

    var formID = _ref.formID,
        formUUID = _ref.formUUID,
        isContextMenu = _ref.isContextMenu,
        rest = _objectWithoutProperties(_ref, ["formID", "formUUID", "isContextMenu"]);

    _classCallCheck(this, ShowHeaderRowFilterButtonProp);

    var props = _objectSpread({
      elementAttr: {
        'class': "show-header-row-filter"
      },
      text: Messages.Controls.ShowTableFilterRow,
      hint: Messages.Controls.ShowTableFilterRow,
      onClick: function onClick(e) {
        _this.UUID = _this._isContextMenu ? _this._props.UUID : _this._props.options.UUID;
        tbShowFilterBtnClicked({
          formUUID: _this.UUID,
          formID: formID
        });
      },
      iconType: 'fontawesome:fas fa-filter',
      isContextMenu: isContextMenu
    }, rest);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShowHeaderRowFilterButtonProp).call(this, props));
    isContextMenu ? _this._props.UUID = formUUID : _this._props.options.UUID = formUUID;
    return _this;
  }

  return ShowHeaderRowFilterButtonProp;
}(BaseToolbarButtonProp);

_defineProperty(ShowHeaderRowFilterButtonProp, "create", function (options) {
  return new ShowHeaderRowFilterButtonProp(options).props();
});

export { ShowHeaderRowFilterButtonProp as default };